//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import loadmore from '@/components/ui/loadmore';
import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';

export default {
    components: {loadmore,cardbox,navbar},
    data(){
        return {
            listData: {
                current_page: 1,
                total: 0,
                per_page: 50,
                data: [],
            },
            typeData: {},
        }
    },
    methods:{

        // 查询列表
        queryList(){
            const opts = {
                url: api.myYakuang,
                data: {},
                type: 'get'
            }
            common.query(opts).then(res=>{
                this.listData = res.data;
            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){
        this.queryList();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/mortgage.vue